import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ConfigCore, ConfigSystem, SystemEnvironment, StaticInjectorService } from '@pit/core';
import configs from './assets/config/config.json'

import { AppModule } from './app/main/app.module';
import { environment } from './environments/environment';

import { HttpClient } from '@angular/common/http';

if (environment.production) {
  enableProdMode();
}

// Loads the Google Maps JavaScript API using the key from runtime configuration
// (config.json -> ConfigGeoData.googleMapsApiKey). Resolves once the script is ready
// so the `google.maps` global is available before the app (and @angular/google-maps) bootstraps.
function loadGoogleMaps(): Promise<void> {
  const apiKey = ConfigCore.configGeoData.googleMapsApiKey;
  if (!apiKey) {
    console.warn('No Google Maps API key configured (GeoData.googleMapsApiKey), skipping map API load');
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      console.warn('Failed to load Google Maps API script');
      resolve();
    };
    document.head.appendChild(script);
  });
}

// StaticInjectorService.setInjector(injector);
// StaticInjectorService.getInjector().get(HttpClient)
fetch('/assets/config/config.json').then(response => response.json()).then(data => {
  ConfigCore.assign(data.config);
}).then(() => {
  // Fetch environment from backend API
  return fetch('/api/web/environment')
    .then(response => response.json())
    .then(envResponse => {
      // Parse backend environment response
      const backendEnv = envResponse?.toLowerCase() || '';

      // Set environment based on backend: Production if "production", otherwise Test
      if (backendEnv === 'production') {
        ConfigSystem.environment = SystemEnvironment.Production;
      } else {
        ConfigSystem.environment = SystemEnvironment.Test;
      }

      console.log(`Environment set from backend: ${backendEnv} -> ${ConfigSystem.environment}`);
    })
    .catch(err => {
      console.warn('Failed to fetch environment from backend, using config.json setting', err);
      // Keep the environment from config.json if backend call fails
    });
}).then(() => {
  // Load the Google Maps API (key comes from runtime config) before bootstrapping the app
  return loadGoogleMaps();
}).then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.log(err));
});
